import React from "react";
import { Route, Routes } from "react-router-dom";
import ShorturlPage from "./ShorturlPage";
import MultiLinkList from "./MultiLinks/List";
import MultiLinkEdit from "./MultiLinks/Edit";
import MultiLinkNew from "./MultiLinks/New";
import AttendanceList from "./Attendance/List";
import AttendanceEdit from "./Attendance/Edit";
import AttendanceNew from "./Attendance/New";

export default function AssociatePage() {
  return (
    <Routes>
      <Route path="/shorturl" element={<ShorturlPage />} />
      <Route path="/multilink/list" element={<MultiLinkList />} />
      <Route path="/multilink/edit" element={<MultiLinkEdit />} />
      <Route path="/multilink/new" element={<MultiLinkNew />} />
      <Route path="/attendance/list" element={<AttendanceList />} />
      <Route path="/attendance/edit" element={<AttendanceEdit />} />
      <Route path="/attendance/new" element={<AttendanceNew />} />
    </Routes>
  );
}
